import EndpointsBase from "../EndpointsBase";

class VerticalLiftEndpoints extends EndpointsBase {
  forceManualShelf(shelfNumber: string, cartID: number) {
    return this._sendRequest({
      method: "verticallift/forcemanualshelf",
      data: { shelfNumber, cartID },
      headers: this._getAuthHeader(),
      run: this.server.postData,
    });
  }
  cancelLiftShelf(shelfNumber: string, cartID: number) {
    return this._sendRequest({
      method: "verticallift/cancelliftshelf",
      data: { shelfNumber, cartID },
      headers: this._getAuthHeader(),
      run: this.server.postData,
    });
  }
}

export default new VerticalLiftEndpoints();
